<template>
    <div>
        <div class="hot">
            <ul class="clear">
                <li class="fl">
                    <img src="@/assets/hot.png" alt="">
                </li>
                <li class="fl">
                    <div class="swipt">
                        <van-swipe vertical :autoplay="3000" style="height: 0.8rem;" :touchable="false">
                            <van-swipe-item  v-for="(item, index) in list_t" :key="index" @click="go">
                            {{item.post_title}}
                            </van-swipe-item>
                        </van-swipe>
                    </div>
                </li>
                <li class="fl">
                    <svg class="icon" aria-hidden="true">
                        <use xlink:href="#iconshuangyoujiantou-"></use>
                    </svg>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import URL from '../api/index'
export default {
    data () {
        return {
            list_t:[],
        }
    },
    mounted(){
        this.$axios({
            method:'post',
            url:URL.xuetang,
            data:{
                type:'top',
                object:'news'
                }
        }).then((res)=>{
            this.list_t = res.data.result
        })
    },
    methods:{
        go(){
            window.location.href = "http://www.rujiaowang.net/app/rdtoutiao/zixun.html"
        },
        icon(){
            window.location.href = "http://www.rujiaowang.net/app/rdtoutiao/zixun.html"
        }
    }
}
</script>

<style scoped>
.hot{
    margin: 0 0.4rem;
    background-color: #f1f3f7;
    border-radius: 0.13333rem;
    color: #2f2f2f;
}
ul li{
    height: 0.8rem;
}
ul li:first-child{
    width: 20%;
    display: flex;
    justify-content: center;
    align-items: center;
}
ul li:nth-child(2){
    width: 70%;
}
ul li:nth-child(3){
    width: 10%;
    display: flex;
    justify-content: center;
    align-items: center;
}
ul li:first-child img{
    width: 1.33333rem;
}
.swipt{
    line-height: 0.8rem;
    font-size: 0.32rem;
}
.van-swipe /deep/ van-swipe-item{
    width: 100%;
}
.swipt /deep/ .van-swipe-item {
    overflow:hidden;
    white-space:nowrap;
    text-overflow:ellipsis;
}
.swipt /deep/ .van-swipe__indicator{
    display: none;
}
.icon{
    font-size: 0.32rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Headline.vue